import { createSelector } from 'reselect'

import { selectIsSelectedDocumentChanged } from 'partner360/features/QBR/selectors/selectIsSelectedDocumentChanged'

import { selectQbrSettingsForm } from './selectQbrSettingsForm'

export const selectIsQbrChanged = createSelector(
  [selectQbrSettingsForm, selectIsSelectedDocumentChanged],
  (form, isSelectedDocumentChanged) => {
    const hasChangedFormFields = form ? form.modifiedFields.length > 0 : false

    return hasChangedFormFields || isSelectedDocumentChanged
  }
)
